import type { PermissionEnum } from '@shared/api';
import { Routes, buildOrganizationRoute } from '@shared/constants/routes';

export const permissionRank: Record<PermissionEnum, number> = {
  MANAGER: 1,
  ADMIN: 2,
  OWNER: 3,
};

export const hasRequiredPermission = (
  selfPermission?: PermissionEnum | null,
  requiredPermission?: PermissionEnum,
) => {
  if (!requiredPermission) return true;
  if (!selfPermission) return false;

  return permissionRank[selfPermission] >= permissionRank[requiredPermission];
};

export const getDefaultPrivateRoute = (selfPermission?: PermissionEnum | null) =>
  hasRequiredPermission(selfPermission, 'ADMIN') ? Routes.analytics.root : Routes.dialogs.root;

export const getDefaultOrganizationRoute = (
  selfPermission?: PermissionEnum | null,
  organizationId?: string | number | null,
) => {
  const defaultRoute = getDefaultPrivateRoute(selfPermission);

  if (!organizationId) {
    return defaultRoute;
  }

  if (defaultRoute === Routes.analytics.root) {
    return buildOrganizationRoute(Routes.organizationScope.analytics, organizationId);
  }

  return buildOrganizationRoute(Routes.organizationScope.dialogs, organizationId);
};
